import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import AppWrapper from './AppWrapper';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './hooks/useAuth';
import { ToastProvider } from './context/toastProvider';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <AuthProvider>
        <ToastProvider>
            <BrowserRouter>
                <AppWrapper />
            </BrowserRouter>
        </ToastProvider>
    </AuthProvider>
);

reportWebVitals();